<script>
import Vue from 'vue'
import AgGridMethods from '@/Mixins/SigmaClientNew/AgGridMethods'
import AgGridTransactionsColumns from '@/Mixins/SigmaClientNew/AgGridTransactionsColumns'
import { AgGridVue } from 'ag-grid-vue'
import AgGridBtnRender from '@/components/SigmaClientNew/AgGridBtnRender'
import { mapGetters } from 'vuex'
import { getHeaders, buildUrlWithQuery } from '@/utils/api'

export default Vue.extend({
  name: 'TransactionsConfList',

  components: {
    AgGridVue
  },
  mixins: [ AgGridMethods, AgGridTransactionsColumns ],

  props: {
    // Name of input field.  Not really necessary, but helpful if we use the form object down the road
    name: {
      required: true,
      type: String
    },

    iteration: {
      required: false,
      type: Number
    },

    classes: {
      required: false,
      type: String,
      default: 'ag-theme-balham'
    },

    rows: {
      required: true
    },

    // Ag-grid column defs
    columns: {
      required: false,
      type: Array,
      default: undefined
    },

    // Ag-grid Options
    options: {
      required: false,
      type: Object,
      default: undefined
    },
    aggridColumns: {
      required: false,
      type: Array
    },
    emitSelect: {
      required: false,
      type: Boolean,
      default: false
    },
    loadingRelated: {
      required: false,
      type: Boolean,
      default: false
    },
    voidingPayment: {
      required: false,
      type: Boolean,
      default: false
    },
    postingPayment: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isError: false, // If the input or selected field is incorrect, show an error
      isLoading: false,
      scope: this,
      gridApi: null,
      columnApi: null,
      defaultColDefs: undefined,
      defaultGridOptions: undefined,
      changes: [],
      frameworkComponents: null,
      rowHeight: 40,
      domLayout: 'autoHeight'
    }
  },

  computed: {
    ...mapGetters({
      currentApsPage: 'getCurrentApPage',
      currentPaymentsPage: 'getCurrentPaymentPage',
      currentPettycashPage: 'getCurrentPcPage',
      currentJesPage: 'getCurrentJePage',
      currentPosPage: 'getCurrentPoPage',
      selection: 'getSelectedTransactions',
      getCurrencyByBatchId: 'getCurrencyByBatchId',
      getFilters: 'getFilters'
    }),
    currentPage () {
      const routeName = {
        'APs': 'currentApsPage',
        'Payments': 'currentPaymentsPage',
        'PCs': 'currentPettycashPage',
        'JEs': 'currentJesPage',
        'PRs': 'currentJesPage',
        'POs': 'currentPosPage'
      }
      return this[routeName[this.$route.name]]
    },
    columnDefs () {
      if (this.columns && Array.isArray(this.columns)) {
        return this.columns
      } else {
        return this.defaultColDefs
      }
    },
    gridOptions () {
      return this.options || this.defaultGridOptions
    },

    // Since we are now sending invoices grouped by invoice, this helper updates each row in the group
    updateChildren () {
      if (!this.rows.length) return false

      this.rows.forEach((group) => {
        group.attributes.resources.forEach((row) => {
          if (!row.data) return false

          row.data.set('payment_confirmation_number', group.attributes.payment_confirmation_number)
          try {
            row.data.save()
          } catch (error) {
            console.log(error)
            return false
          }
        })
      })

      return true
    },
     // Any groups with at least one transaction selected
    selectedNodes () {
      let aggregatedNodes = []
      this.gridApi.forEachNode((node) => {
        console.log('node', node)
        if (node.selected) {
          aggregatedNodes.push(node)
        }
      })
      return aggregatedNodes
    },

    // Since we are now sending invoices grouped by invoice, this helper makes each group look like a transaction
    simulatedPaymentTransactionData () {
      if (!this.selectedNodes.length) return []

      let transactions = []
      this.selectedNodes.forEach((node) => {
        const transaction = {
          attributes: node.data.attributes
        }
        transactions.push(transaction)
      })

      return transactions
    },
    width () {
      return `calc(100vw - 200px)`
    }
  },

  methods: {
    // Ag-grid
    onGridReady (params) {
      if (!params) return
      this.gridApi = params.api
      this.columnApi = params.columnApi
    },
    onFirstDataRendered (params) {
      if (!params) return
      if (params.api.gridPanel.bodyHeight) params.api.sizeColumnsToFit()
    },

    onChangeVisibleColumns () {
      this.$nextTick(() => {
        this.gridApi.sizeColumnsToFit()
      })
    },

    exportToExcel () {
      this.gridApi.exportDataAsExcel()
    },
    updateSelection (gridApi) {
      const api = gridApi || this.gridApi
      if (!api) return
      let selected = []
      api.forEachNode((row) => {
        if (row && row.selected && row.data) {
          selected.push(row.data)
        }
      })
      if (this.emitSelect) {
        this.$emit('onSelect', selected)
      } else {
        let notThisPage = this.selection.filter(v => v.page !== this.currentPage)
        this.$store.dispatch('updateTransactionSelection', [...notThisPage, ...selected])
      }
    },
    prepareColumns (columns) {
      this.actionsColumn.cellRendererParams = {
        clickhandleVoidDialogVisible: this.clickhandleVoidDialogVisible,
        postPayment: this.postPayment,
        loadingRelated: this.loadingRelated,
        postingPayment: this.postingPayment,
        voidingPayment: this.voidingPayment
      }
      if (columns && columns.length) {
        return this.aggridColumns.map((c) => this[c])
      } else {
        return [
          this.rowSelect,
          this.ledgerColumn,
          this.numberColumn,
          this.vendorColumn,
          this.descriptionColumn,
          this.amountColumn,
          this.batchColumn,
          this.actionsColumn,
          this.dueDateColumn
        ]
      }
    },
    deselectAll () {
      this.gridOptions.api.deselectAll()
    },
    clickhandleVoidDialogVisible (data) {
      this.$emit('handleVoidDialogVisible', data)
    },
    postPayment (data) {
      this.$emit('postPayment', data)
    },
    getLoading () {
      return this.loadingRelated
    },
    getVoiding () {
      return this.voidingPayment
    },
    getPosting () {
      return this.postingPayment
    },
    restoreSelection (data, key = 'id', page = this.currentPage) {
      if (!(data && data.length)) return
      const thisPageSelectedIds = data
        .filter(v => v.page === page)
        .map(v => v[key])
      this.gridOptions.api.forEachNode(node => thisPageSelectedIds.includes(node.data[key]) ? node.setSelected(true) : 0)
    },
    // Sort data by selected column
    async sortDataBySelectedColumn (params) {
      // Get route and column info
      const routeInfo = this.$route
      const sortedColumn = params.columnApi.getColumnState().find(col => Boolean(col.sort))

      // Check route name and selected column
      if (routeInfo.name === 'Payments' && sortedColumn && (sortedColumn.colId === 'bank' || sortedColumn.colId === 'vendor')) {
        // Append '_name' to the 'bank' or 'vendor' field to get the sorted data
        sortedColumn.colId += '_name'
      }

      // Get route name and assign path URL and default column
      const routeName = {
        APs: 'aps',
        Payments: 'payments',
        PCs: 'pcs',
        JEs: 'jes',
        POs: 'pos',
        PRs: 'jes'
      }[routeInfo.name]

      // Check if route name exists
      if (!routeName) {
        return
      }

      // Get active instance URL info and headers
      const instanceUrl = this.$store.getters.getActiveInstance.url
      const headers = getHeaders(this.$store.getters.getToken)

      // Get field value and current page
      const fieldValue = sortedColumn && sortedColumn.sort === 'asc' ? sortedColumn.colId : sortedColumn && sortedColumn.sort === 'desc' ? `-${sortedColumn.colId}` : ''
      const currentPage = `${this.currentPage}`

      this.$store.dispatch('unsetFilter', 'ordering')
      // Construct query
      const query = {
        ...(fieldValue ? { ordering: fieldValue } : {}),
        ...(currentPage ? { page: currentPage } : {}),
        ...this.getFilters
      }

      // Set filter and dispatch API call
      this.$store.dispatch('setFilter', query)
      if (routeName !== 'payments') {
      // API to sort the data
        const response = Vue.http.get(buildUrlWithQuery(routeName, query, instanceUrl), { headers })
          .then(response => {
            // Check results data is exist or not
            if (response && response.body && response.body.results) this.rows = response.body.results
          })
          .catch(error => console(error))
        await this.$store.dispatch('unsetFilter', 'page')
        return response
      } else {
        await this.$store.dispatch('resetPaymentMeta')
        await this.$store.dispatch('clearPaymentState', true)
        await this.$store.commit('CLEAR_CACHE')
        let response = await this.$store.dispatch('fetchPaymentsWithQuery', query)
        this.rows = Object.values(response.entities.payments)
        await this.$store.dispatch('unsetFilter', 'page')
      }
    }
  },
  beforeMount () {
    this.defaultColDefs = this.prepareColumns(this.aggridColumns)
    this.defaultGridOptions = {
      singleClickEdit: true,
      undoRedoCellEditing: false,
      enterMovesDown: true,
      enterMovesDownAfterEdit: true,
      rowSelection: 'multiple',
      defaultColDef: {
        resizable: true,
        menuTabs: [],
        suppressSizeToFit: false
      },
      pinnedBottomRowData: [],
      enableRangeSelection: true,
      animateRows: true,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      // Classes and events
      rowClassRules: {
        'ag-error': (params) => params.node.aggData && !this.hasCompleteAchData(params.node.aggData.vendorResource)
      },
      onGridReady: (params) => this.onGridReady(params),
      onFirstDataRendered: (params) => this.onFirstDataRendered(params),
      onSelectionChanged: (params) => {
        this.updateSelection(params.api)
      },
      onSortChanged: (params) => {
        this.rows = []
        // Sort data by selected column
        this.sortDataBySelectedColumn(params)
      }
    }
    this.frameworkComponents = {
      agGridBtnRender: AgGridBtnRender
    }
  },
  watch: {
    aggridColumns (val) {
      this.gridOptions.api.setColumnDefs([])
      this.gridOptions.api.setColumnDefs(this.prepareColumns(val))
    },
    selection (val) {
      if (this.gridApi) {
        const selectedData = this.gridApi.getSelectedRows()
        if (!(val && val.length) && selectedData && selectedData.length) {
          this.gridOptions.api.deselectAll()
        }
      }
    }
  }
})
</script>

<template>
  <ag-grid-vue
    :name="name"
    :ref="name"
    :class="classes"
    :rowHeight="rowHeight"
    :style="{width, margin: '17px'}"
    :column-defs="columnDefs"
    :row-data="rows"
    :grid-options="gridOptions"
    :dom-layout="domLayout"
    :frameworkComponents="frameworkComponents"
  />
</template>
<style scoped>
.ag-theme-balham .ag-row .ag-cell {
  display: flex !important;
  justify-content: center !important; /* align horizontal */
  align-items: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SigmaClientNew/TransactionsConfList.vue